// getIsSupportApplePay.js
/**
 * Checks if Apple Pay is supported and can make payments on the current device.
 * @returns {boolean} Returns True/False depending on Apple Pay is supported or not.
 */
function getIsSupportApplePay() {
  if (window.ApplePaySession) {
    return window.ApplePaySession.canMakePayments();
  } else {
    return false;
  }
}

/**
 * Checks if the user has an active card in Apple Wallet that can be used with Apple Pay.
 *
 * @param {string} merchantIdentifier - The unique identifier for the merchant.
 * @returns {Promise<boolean>} - A promise that resolves to `true` if the user has an active card, `false` if not.
 *                              If Apple Pay is not supported, it resolves to `false`.
 */
export async function checkApplePayActiveCard(merchantIdentifier) {
  if (getIsSupportApplePay()) {
    return await window.ApplePaySession.canMakePaymentsWithActiveCard(
      merchantIdentifier
    )
      .then(canMakePayments => canMakePayments)
      .catch(() => false);
  } else {
    return false;
  }
}

export default getIsSupportApplePay;
